import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo-link">
          <div className="logo">Index Millionaire</div>
        </Link>
        <nav>
          <Link to="/steps-to-financial-freedom" className="nav-link">The Steps</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header; 